import { ApiCaller } from "@virtual-brain-lib/frontend-api";
import { Button } from "@virtual-brain-lib/frontend-design-system/ui";

import { useChatContext } from "../../core";

export default function MessageSuggestedFollowUpCard({
	text,
	onClick,
}: {
	readonly text: string;
	readonly onClick?: (() => void) | undefined;
}) {
	const { analyticsEventDomain } = useChatContext();

	function handleClick() {
		if (onClick) {
			ApiCaller.track([analyticsEventDomain, "Followup-question", "Clicked"]);
			onClick();
		}
	}

	return (
		<Button
			variant="ghost"
			textPosition="center"
			classNames={{
				wrapper: "w-full h-fit",
				base: "min-h-15",
				text: "line-clamp-2 text-xs",
			}}
			onClick={handleClick}
		>
			{text}
		</Button>
	);
}
